import CookiesService from 'services/CookiesService';

const accessTokenStorage = new CookiesService(process.env.REACT_APP_AUTH_TOKEN_NAME, { string: true });

export default accessTokenStorage;
